import React from 'react';
import ReactDOM from 'react-dom/client';
import './assests/css/animate.min.css';
import './assests/css/main.css';
import App from './App';
import {Provider} from 'react-redux';
import store from './redux/store/store';
import { useDispatch } from 'react-redux';
import { getTotals } from './redux/slices/cartSlice';

// const dispatch = useDispatch()
// dispatch(getTotals())

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);